import * as React from "react";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { Form, Row, Col } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { AuthContext } from "src/components/context/AuthContext";
import Button from "src/components/common/Button";

function RequestRecoveryCode(props: FormComponentProps & { onConfirmed: (email: string) => void }) {
  const [email, setEmail] = React.useState("");
  const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const authContext = React.useContext(AuthContext);

  const [loading, setLoading] = React.useState(false);

  function validateAndSendEmail(e: React.FormEvent) {
    e.preventDefault();
    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      if (!errs && props.onConfirmed) {
        setLoading(true);
        authContext.forgotPassword(email).finally(() => {
          setLoading(false);
          props.onConfirmed(email);
        });
      }
    });
  }

  return (
    <Form style={{ maxWidth: "759px", margin: "0 auto" }} onSubmit={e => validateAndSendEmail(e)}>
      <h2 className="decode-recovery-title">Alterar senha</h2>
      <span className="decode-recovery-content">
        Informe seu e-mail e enviaremos um <strong>código</strong> para a recuperação de senha.
      </span>
      <div className="decode-recovery-group">
        <PbrInput
          autoFocus
          value={email}
          onChange={e => setEmail(e.target.value)}
          name="email"
          title="Informe um e-mail válido"
          formItemProps={{ label: "" }}
          placeholder="E-mail"
          formWrapper={props.form}
          rules={[{ required: true, message: "Informe um e-mail válido", pattern: emailRegex }]}
        />

        <Row className="actions-btn-row">
          <Col xs={24} sm={24} md={24} lg={24}>
            <Button loading={loading}>Enviar</Button>
          </Col>
        </Row>
      </div>
    </Form>
  );
}

export default Form.create()(RequestRecoveryCode);



// WEBPACK FOOTER //
// ./src/pages/password-recover/RequestRecoveryCode.tsx